import React from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";

const CustomTimePicker = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "Select Time",
  allowClear = true,
  size = "middle",
  disableFuture = false,
  disablePast = false,
  format = "HH:mm", // 24-hour format
  className = "",
  ...props
}) => {

  const disabledHours = () => {
    const hours = [];
    const currentHour = dayjs().hour();

    if (disablePast) {
      for (let i = 0; i < currentHour; i++) {
        hours.push(i);
      }
    }

    if (disableFuture) {
      for (let i = currentHour + 1; i < 24; i++) {
        hours.push(i);
      }
    }

    return hours;
  };

  const disabledMinutes = (selectedHour) => {
    const minutes = [];
    const currentHour = dayjs().hour();
    const currentMinute = dayjs().minute();

    if (disablePast && selectedHour === currentHour) {
      for (let i = 0; i < currentMinute; i++) {
        minutes.push(i);
      }
    }

    if (disableFuture && selectedHour === currentHour) {
      for (let i = currentMinute + 1; i < 60; i++) {
        minutes.push(i);
      }
    }

    return minutes;
  };

  return (
    <TimePicker
      format={format}
      value={value ? dayjs(value, format) : null}
      onChange={(time) => onChange(time ? dayjs(time).format(format) : null)}
      onBlur={(e) => onBlur({ target: { name } })}
      name={name}
      style={{ width: "100%" }}
      placeholder={placeholder}
      allowClear={allowClear}
      size={size}
      disabledHours={disableFuture || disablePast ? disabledHours : undefined}
      disabledMinutes={disableFuture || disablePast ? disabledMinutes : undefined}
      className={className}
      {...props}
    />
  );
};

export default CustomTimePicker;

// import React, { useMemo } from "react";
// import { TimePicker } from "antd";
// import dayjs from "dayjs";

// const CustomTimePicker = ({
//   name,
//   value,
//   onChange,
//   onBlur,
//   placeholder = "Select Time",
//   allowClear = true,
//   size = "middle",
//   disableFuture = false,
//   disablePast = false,
//   format = "HH:mm",
//   className = "",
//   ...props
// }) => {

//   /* --------------------------------------------------
//      Normalize incoming value (string | dayjs | null)
//   -------------------------------------------------- */
//   const normalizedValue = useMemo(() => {
//     if (!value) return null;
//     return dayjs.isDayjs(value) ? value : dayjs(value, format);
//   }, [value, format]);

//   /* --------------------------------------------------
//      Disable logic
//   -------------------------------------------------- */
//   const disabledHours = () => {
//     const now = dayjs();
//     const hours = [];

//     if (disablePast) {
//       for (let i = 0; i < now.hour(); i++) hours.push(i);
//     }

//     if (disableFuture) {
//       for (let i = now.hour() + 1; i < 24; i++) hours.push(i);
//     }

//     return hours;
//   };

//   const disabledMinutes = (selectedHour) => {
//     const now = dayjs();
//     const minutes = [];

//     if (disablePast && selectedHour === now.hour()) {
//       for (let i = 0; i < now.minute(); i++) minutes.push(i);
//     }

//     if (disableFuture && selectedHour === now.hour()) {
//       for (let i = now.minute() + 1; i < 60; i++) minutes.push(i);
//     }

//     return minutes;
//   };

//   return (
//     <TimePicker
//       format={format}
//       value={normalizedValue}             // ✅ stable dayjs
//       onChange={(time) => onChange(time)} // ✅ emit dayjs
//       onBlur={() => onBlur?.({ target: { name } })}
//       name={name}
//       style={{ width: "100%" }}
//       placeholder={placeholder}
//       allowClear={allowClear}
//       size={size}
//       disabledHours={disableFuture || disablePast ? disabledHours : undefined}
//       disabledMinutes={disableFuture || disablePast ? disabledMinutes : undefined}
//       className={className}
//       {...props}
//     />
//   );
// };

// export default CustomTimePicker;
